import { css } from '@emotion/react'
import { memo } from 'react'
import { activeGreen } from '../theme'

const rootStyles = css({
    width: '100%',
    height: '10px',
})
const linearProgress = css({
    backgroundColor: 'lightgray',
    height: '10px',
    position: 'relative',
    display: 'block',
    overflow: 'hidden',
    '& span': {
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        transition: 'transform 0.4s linear',
    },
})
type PercentageBarProps = {
    color: string
    percentage: number
}

const PercentageBar = (props: PercentageBarProps) => {
    const { color, percentage } = props

    const displayColor =
        color === '#000000' || color === undefined ? activeGreen : color

    const offset = percentage - 100
    return (
        <div css={rootStyles}>
            <span
                css={linearProgress}
                style={{
                    border: `1px solid ${displayColor}`,
                }}
            >
                <span
                    style={{
                        backgroundColor: displayColor,
                        transform: `translateX(${offset}%)`,
                    }}
                />
            </span>
        </div>
    )
}

export default memo(PercentageBar)
